module.exports = __webpack_public_path__ + "static/img/guide_5_0.27873e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_5_0.jpg
// module id = 1ib9
// module chunks = 1